module.exports = __webpack_public_path__ + "img/medalha-sala-do-empreendedor.1cc9ba13.jpg";